import { ref } from 'vue';
import type { Ref, Component } from 'vue';

// Dialog object type
type Dialog = {
  type?:
    | 'timeline'
    | 'dependencies'
    | 'unfinished'
    | 'user'
    | 'exports'
    | 'images'
    | 'dataset'
    | 'matrix'
    | 'placeholders'
    | 'cityInfo';
  message?: string;
  header?: string;
  component?: Component;
  modal?: boolean;
  dismissable?: boolean;
  showHeader?: boolean;
  showMaximized?: boolean;
  position?: 'center' | 'left' | 'top' | 'bottom' | 'right' | 'topleft' | 'topright' | 'bottomleft' | 'bottomright';
  data?: any;
  callback?: {
    onConfirm?: (arg: any) => Promise<void> | void;
    onCompute?: (arg: any) => Promise<void> | void;
    onSave?: (arg: any) => Promise<void> | void;
    onLeave?: (arg: any) => Promise<void> | void;
    onCancel?: (arg: any) => Promise<void> | void;
    onEventClick?: (tEv: TmTimelineEvent) => Promise<void> | void;
    onModificationClick?: (tEv: TmTimelineEvent) => Promise<void> | void;
    onImageSelection?: (img: string) => Promise<void> | void;
    onPlaceholderSelection?: (placeholder: string) => Promise<void> | void;
  };
};

// global refs
const displayed = ref<boolean>(false);
const dialog = ref<Dialog>({});

export default function useDialog(): {
  dialog: Ref<Dialog>;
  displayed: Ref<boolean>;
  show: (dialogOptions: Dialog) => void;
  close: () => void;
} {
  const show = (dialogOptions: Dialog) => {
    dialog.value = dialogOptions;
    displayed.value = true;
  };

  const close = () => {
    displayed.value = false;
    dialog.value = { position: dialog.value.position, modal: dialog.value.modal }; // clear dialog options, but keep old positioning for the delayed close animation
  };

  return { dialog, displayed, show, close };
}
